import { render, staticRenderFns } from "./fuwu.vue?vue&type=template&id=2f3b3956&scoped=true"
import script from "./fuwu.vue?vue&type=script&lang=js"
export * from "./fuwu.vue?vue&type=script&lang=js"
import style0 from "./fuwu.vue?vue&type=style&index=0&id=2f3b3956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3b3956",
  null
  
)

export default component.exports